export default __webpack_public_path__ + "static/media/webdesignimg.c44226c2.png";